import { Deal, HaircutSign } from 'api'
import { getHaircutFormatOptions } from '../datagrid'
import { TableCell } from './servicingDialogStyles'
import { Locale } from 'locale'
import React from 'react'

export const HaircutCell: React.FunctionComponent<{
  hideHaircutColumn: boolean
  deal: Deal
  haircutSign: HaircutSign
  ownOrder: boolean
  testId?: string
  left?: boolean
}> = ({ hideHaircutColumn, deal, haircutSign, ownOrder, testId, left = false }) => {
  return !hideHaircutColumn ? (
    <TableCell flex={1} left={left}>
      <span data-test-id={testId}>
        {Locale.formatNumber(deal.haircut, getHaircutFormatOptions(undefined, haircutSign, ownOrder, deal.direction))}
      </span>
    </TableCell>
  ) : (
    <></>
  )
}
